import { STORAGE_KEY } from '@/constants/storage';

export default class AuthCommunicator {
  static instance = null;

  constructor(iframeSrc) {
    if (AuthCommunicator.instance) {
      // eslint-disable-next-line no-constructor-return
      return AuthCommunicator.instance;
    }

    this.iframe = document.createElement('iframe');
    this.iframe.setAttribute(
      'src',
      iframeSrc || 'https://www.bigo.tv/ssr/auth-iframe?source=agent',
    );

    this.iframe.style.width = '0';
    this.iframe.style.height = '0';
    this.iframe.style.border = 'none';
    this.iframe.style.position = 'absolute';
    this.iframe.style.left = '-9999px';

    document.body.appendChild(this.iframe);

    this.isReady = false;

    // Queue to store intercepted postMessage calls
    this.messageQueue = [];

    this.handleMessage = this.handleMessage.bind(this);
    window.addEventListener('message', this.handleMessage);

    AuthCommunicator.instance = this;
  }

  static getInstance(iframeSrc) {
    return AuthCommunicator.instance || new AuthCommunicator(iframeSrc);
  }

  postMessage(message) {
    const msgObj = {
      ...message,
      origin: window.location.origin,
    };

    if (this.isReady) {
      this.iframe.contentWindow.postMessage(msgObj, this.iframe.src);
    } else {
      // Check for duplicates based on message type before adding to the queue
      const isDuplicate = this.messageQueue.some(
        (queuedMessage) => queuedMessage.type === msgObj.type,
      );
      if (!isDuplicate) {
        this.messageQueue.push(msgObj);
      }
    }
  }

  handleMessage(event) {
    if (event.source === this.iframe.contentWindow && event.data.type === 'READY') {
      this.isReady = true;
      // Resend queued postMessage calls after receiving READY
      this.messageQueue.forEach((queuedMessage) => {
        this.postMessage(queuedMessage);
      });
      this.messageQueue = []; // Clear the message queue
    }
  }

  getToken() {
    return new Promise((resolve) => {
      // 5s后没有收到消息 就认为是获取token失败
      const timer = setTimeout(() => {
        window.removeEventListener('message', onMessage);
        resolve(null);
      }, 5000);

      const clear = () => {
        window.removeEventListener('message', onMessage);
        clearTimeout(timer);
      };

      const onMessage = (event) => {
        const { type, data } = event.data;
        if (event.source === this.iframe.contentWindow && type === 'NEW_TOKEN') {
          clear();
          resolve(data?.token);
        }
      };

      window.addEventListener('message', onMessage);

      this.postMessage({
        type: 'EXCHANGE_TOKEN',
        data: { deviceId: localStorage.getItem(STORAGE_KEY.DEVICE_ID) },
      });
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        window.removeEventListener('message', handleMessage);
        reject();
      }, 5000);

      const clear = () => {
        window.removeEventListener('message', handleMessage);
        clearTimeout(timer);
      };

      const handleMessage = (event) => {
        const { type } = event.data;
        if (event.source === this.iframe.contentWindow) {
          if (type === 'LOGOUT_SUCCESS') {
            clear();
            resolve();
          } else if (type === 'LOGOUT_ERROR') {
            clear();
            reject();
          }
        }
      };

      window.addEventListener('message', handleMessage);

      this.postMessage({ type: 'LOGOUT' });
    });
  }

  destroy() {
    window.removeEventListener('message', this.handleMessage);

    if (this.iframe.parentNode) {
      this.iframe.parentNode.removeChild(this.iframe);
    }

    AuthCommunicator.instance = null;
  }
}
